// extracted by mini-css-extract-plugin
module.exports = {"light":"Wrapper_light__1w0Nl","card":"Wrapper_card__3KDe1","loaderBlock":"Wrapper_loaderBlock__20CfA","noData":"Wrapper_noData__H1Hts","sourceList":"Wrapper_sourceList__1jbhF"};